import React from 'react';

import { type LabelProps } from './types';
import { cn } from '../../utils/cn';

/**
 * A label component for form inputs.
 *
 * @param children - Label text content.
 * @param htmlFor - ID of the form control the label is associated with.
 * @param className - Additional CSS classes to merge with default styles.
 * @param ...props - Additional HTML label attributes.
 *
 * @example
 * <Label htmlFor="firstName">First Name</Label>
 *
 * @example
 * <Label htmlFor="email" className="w-32">Email</Label>
 *
 * @example
 * <Label>
 *   <input type="checkbox" />
 *   Accept terms
 * </Label>
 */
export const Label: React.FC<LabelProps> = ({ children, className, ...props }) => {
    return (
        <label
            className={cn(
                'flex items-center justify-center',
                'px-3.75 py-1.625',
                'text-sm leading-[1.46] text-midnight',
                className,
            )}
            {...props}
        >
            {children}
        </label>
    );
};
